import { render, staticRenderFns } from "./SectionContactUs.vue?vue&type=template&id=279e2c88&scoped=true"
import script from "./SectionContactUs.vue?vue&type=script&lang=js"
export * from "./SectionContactUs.vue?vue&type=script&lang=js"
import style0 from "./SectionContactUs.vue?vue&type=style&index=0&id=279e2c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279e2c88",
  null
  
)

export default component.exports